// Centralized module & permission configuration
// Used by Sidebar, UserManagement, and individual pages

export const MODULE_SECTIONS = [
  {
    key: "cotizaciones",
    label: "Comercial",
    children: [
      { key: "cotizaciones_nueva", label: "Nueva Cotización" },
      { key: "cotizaciones_historial", label: "Cotizaciones Realizadas" },
      { key: "cotizaciones_tabla", label: "Tabla Cotizadora" },
      { key: "comercial_dashboard", label: "Dashboard Comercial" },
    ],
  },
  {
    key: "clientes",
    label: "Clientes",
    children: [
      { key: "cabina_expedientes", label: "Ventas · Cabina de Ventas" },
      { key: "cabina_ver_margenes", label: "Ventas · Ver márgenes y utilidad" },
      { key: "clientes_nuevo", label: "Nuevo Cliente" },
      { key: "clientes_crm", label: "Clientes CRM" },
      { key: "clientes_encuestas", label: "Encuestas de Calidad" },
      { key: "clientes_formularios_servicios", label: "Formularios clientes · Cotizaciones" },
      { key: "clientes_formularios_accesos", label: "Formularios clientes · Administrar accesos" },
      { key: "clientes_directorio_contactos", label: "Directorio de Contactos" },
    ],
  },
  {
    key: "logistica",
    label: "Logística",
    children: [
      { key: "logistica_productos", label: "Productos" },
      { key: "logistica_inventarios", label: "Inventarios" },
      { key: "logistica_pedidos", label: "Pedidos" },
      { key: "logistica_vehiculos", label: "Vehículos" },
    ],
  },
  {
    key: "traveldesk",
    label: "Traveldesk",
    children: [
      { key: "traveldesk_calculadora", label: "Calculadora de Precios" },
      { key: "traveldesk_itinerarios", label: "Itinerarios" },
      { key: "traveldesk_perfil_viajero", label: "Perfil de Viajero (Viajero Interno)" },
      { key: "traveldesk_perfil_viajero_externo", label: "Perfil de Viajero (Viajero Externo)" },
      { key: "traveldesk_formularios_btravel", label: "Formularios BTravel" },
      { key: "traveldesk_formularios_btravel_consola", label: "Formularios BTravel · Consola de Solicitudes" },
      { key: "traveldesk_dashboard_servicios", label: "Dashboard de Servicios" },
    ],
  },
  {
    key: "hospitality",
    label: "Hospitality",
    children: [
      { key: "hospitality_perfil_viajero", label: "Perfil de Viajero (Viajero Interno)" },
      { key: "hospitality_perfil_viajero_externo", label: "Perfil de Viajero (Viajero Externo)" },
    ],
  },
  {
    key: "administracion",
    label: "Administración",
    children: [
      { key: "activos_fijos", label: "Activos Fijos" },
      { key: "erp_facturacion", label: "ERP · Facturación" },
      { key: "erp_vinculacion", label: "ERP · Vinculación Clientes" },
      { key: "cabina_costos", label: "Ventas · Tablero de Costos" },
      { key: "cabina_matriz_fiscal", label: "Ventas · Matriz Fiscal" },
      { key: "admin_facturacion_global", label: "Ventas · Facturas Globales" },
      { key: "admin_pagos_globales", label: "Ventas · Pagos Globales" },
      { key: "admin_ventas_pendientes", label: "Ventas · Pendientes de aprobación" },
      { key: "admin_monedas_config", label: "Monedas · Configuración" },
      { key: "admin_monedas_tc", label: "Monedas · Tipos de Cambio" },
    ],
  },
  {
    key: "configuracion_section",
    label: "Configuración",
    children: [
      { key: "config_agencia", label: "Datos de la Agencia" },
      { key: "config_opciones", label: "Opciones" },
      { key: "config_usuarios", label: "Usuarios" },
      { key: "config_paginas_publicas", label: "Páginas públicas" },
      { key: "cabina_laboratorio", label: "Ventas · Laboratorio" },
      { key: "config_tablas_aeropuertos", label: "Tablas: Aeropuertos" },
      { key: "config_tablas_destinos", label: "Tablas: Destinos" },
      { key: "config_tablas_aerolineas", label: "Tablas: Aerolíneas" },
      { key: "config_tablas_hoteles", label: "Tablas: Hoteles" },
      { key: "config_tablas_proveedores", label: "Tablas: Proveedores de Gastos" },
      { key: "config_tablas_articulos", label: "Tablas: Artículos" },
      { key: "config_tablas_centros", label: "Tablas: Centros de Trabajo" },
      { key: "config_tablas_empleados", label: "Tablas: Empleados" },
      { key: "config_tablas_departamentos", label: "Tablas: Departamentos Operativos" },
      { key: "config_tablas_categorias_tkt", label: "Tablas: Categorías de Tickets" },
    ],
  },
  {
    key: "helpdesk",
    label: "Helpdesk",
    children: [
      { key: "helpdesk_tickets", label: "Tickets" },
      { key: "helpdesk_contactos", label: "Contactos" },
      { key: "helpdesk_metricas", label: "Métricas" },
      { key: "helpdesk_quick_replies", label: "Respuestas rápidas" },
    ],
  },
];

export const ALL_MODULE_KEYS = MODULE_SECTIONS.flatMap(s => s.children.map(c => c.key));

export const DEFAULT_MODULES = Object.fromEntries(ALL_MODULE_KEYS.map(k => [k, false]));

export const DEFAULT_MODULES_EDIT = Object.fromEntries(ALL_MODULE_KEYS.map(k => [k, false]));

/** Admin always has access. Others check their modules dict. */
export const canAccessModule = (user, moduleKey) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  return user.modules?.[moduleKey] === true;
};

/** Returns true if ANY child in a section is accessible */
export const canAccessSection = (user, sectionKey) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const section = MODULE_SECTIONS.find(s => s.key === sectionKey);
  if (!section) return false;
  return section.children.some(c => user.modules?.[c.key] === true);
};

/** Per-module edit check. Admin always can. Others need modules_edit[key] === true */
export const canEditModule = (user, moduleKey) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  return user.modules_edit?.[moduleKey] === true;
};

/** Can edit in ANY module within a section */
export const canEditInSection = (user, sectionKey) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  const section = MODULE_SECTIONS.find(s => s.key === sectionKey);
  if (!section) return false;
  return section.children.some(c => user.modules_edit?.[c.key] === true);
};

/** Legacy: Admin + Supervisor can edit (fallback) */
export const canEdit = (user) => {
  if (!user) return false;
  return ["admin", "supervisor"].includes(user.role);
};

/** Only Admin can delete */
export const canDelete = (user) => {
  if (!user) return false;
  return user.role === "admin";
};
